import {  useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "../../styles/owner/HomeOwner.css"; // Import the CSS file for styling
import BASE_URL from "../../BaseUrl";
import StarRating from "../admin/StarRating";

export default function WatingAdminsSection({message, setMessage, showMessage, setShowMessage,reloadAdmins,setReloadAdmins}) {

    const navigate = useNavigate();
    const [admins, setAdmins] = useState([]);
    


    //for edit admin info

    //for update admin plane

    //for Deleting the admin info
    const [showDeleteAdmin, setShowDeleteAdmin] = useState(false);
    const [idToDelete, setIdToDelete] = useState("");

    // for reloadding the admins and courses
    const [reloadding, setReloadding] = useState(false);

    // for admin details popup
    const [showAdminDetails, setShowAdminDetails] = useState(false);
    const [adminDetails, setAdminDetails] = useState(null);

   
   
    // delete admin function
    const rejectAdmin = () => {
        axios.delete(`${BASE_URL}/owner/reject-admin?adminId=${idToDelete}`, { withCredentials: true })
            .then((response) => {
                setReloadding(!reloadding); // toggle reloadding to refresh the admins list
                if(response.data){
                  setMessage("تم رفض المدرس بنجاح");
                }else{
                  setMessage("حدث خطأ أثناء رفض المدرس");
                }
                setShowMessage(true);
                setShowDeleteAdmin(false);
                setIdToDelete("");
            }).catch((error) => {
              console.log(error);
                setMessage(error.response.data || "An error occurred while deleting the admin.");
                setShowMessage(true);
                setShowDeleteAdmin(false);});
            }

    const approveAdmin = (adminId) => {
        axios.post(`${BASE_URL}/owner/approve-admin?adminId=${adminId}`,{} ,{ withCredentials: true })
            .then((response) => {
                if(response.data){
                  setMessage("تم قبول المدرس بنجاح");
                  setReloadAdmins(!reloadAdmins); 
                }
                else{
                  setMessage("حدث خطأ أثناء قبول المدرس");
                }
                setShowMessage(true);
                setReloadAdmins(!reloadAdmins); // toggle reloadding to refresh the admins list
            }).catch((error) => {
                setMessage(error.response.data || "An error occurred while accepting the admin.");
                setShowMessage(true);
            });
    }
            
            
    useEffect(() => {
        axios.get(BASE_URL+"/owner/waiting-admins", { withCredentials: true })
        .then((response) => {
            setAdmins(response.data);
        }).catch((error) => {
            navigate("/");
        });
    }, [reloadAdmins,reloadding,navigate]);

    
    
    return (
        <div className="admins-section-container">
            <h2>قائمة الانتظار </h2>
            <table className="admins-table">
            <thead>
                <tr>
                <th>حذف</th>
                <th>عرض التفاصيل</th>
                <th>قبول</th>
                <th>البريد الإلكتروني</th>
                <th>الاسم</th>
                </tr>
            </thead>
            <tbody>
            {admins.map((admin, index) => (
                <tr key={index} className="admin-card">
                <td><button onClick={() => {setIdToDelete(admin.id);setShowDeleteAdmin(true)}}>حذف</button></td>
                <td><button onClick={() => {setAdminDetails(admin);setShowAdminDetails(true)}}>عرض التفاصيل</button></td>
                <td><button onClick={() => {approveAdmin(admin.id)}}>قبول</button></td>
                <td>{admin.email}</td>
                <td>{admin.name}</td>
                </tr>
            ))}
            </tbody>
            </table>
            

            { showAdminDetails && (
                <div className="overlay">
                <div className="admin-details-form" dir="rtl">
                    <h3>معلومات المدرس</h3>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}} dir="ltr">
                        <div style={{width:"150px",height:"150px"}}>
                            <img
                            src={
                            `${BASE_URL}/owner/admin-image?adminId=${adminDetails.id}&ext=${adminDetails.imageExt}` 
                            }
                            alt="avatar"
                            className="avatar"
                            />
                            </div>
                            <StarRating rate={adminDetails.rate}/>
                            <div style={{display:"flex",justifyContent:"space-between",width:"100%"}} dir="ltr">
                            <h6>التقييمات {adminDetails.numberOfRates}</h6>
                                <h6>التقييم {adminDetails.rate}</h6>
                            </div>
                    </div>
                    <label>الاسم</label>
                    <input
                        type="text"
                        value={adminDetails.name}
                        readOnly/>
                    <label>البريد الإلكتروني</label>
                    <input
                        type="email"
                        value={adminDetails.email}
                        readOnly/>
                        
                    <label>رقم الهاتف</label>
                    <input
                        type="text"
                        value={adminDetails.phone}
                        readOnly/>
                    <label>التخصص</label>
                    <input
                        type="text"
                        value={adminDetails.field}
                        readOnly/>
                    <label>السعة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity}
                        readOnly/>

                    <label>السعة المستخدمة</label>
                    <input
                        type="number"
                        value={adminDetails.usedCapacity}
                        readOnly/>

                    <label>السعة المتاحة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity-adminDetails.usedCapacity}
                        readOnly/>

                    <label>الطلاب</label>
                    <input
                        type="number"
                        value={adminDetails.students}
                        readOnly/>

                    <label>الطلاب الحاليين</label>
                    <input
                        type="number"
                        value={adminDetails.currentStudent}
                        readOnly/>
                    <label>المساعدين</label>
                    <input
                        type="number"
                        value={adminDetails.assistants}
                        readOnly/>
                    <label>المساعدين الحاليين</label>
                    <input 
                        type="number"
                        value={adminDetails.currentAssistants}
                        readOnly/>
                     <label>تاريخ الانتهاء</label>
                    <input
                        type="date"
                        value={adminDetails.expire}
                        readOnly/>
                    <button onClick={() => setShowAdminDetails(false)}>إغلاق</button>
                </div>
                <div></div>
                </div>
            )}

            { showDeleteAdmin && (
                <div className="delete-admin-confirmation">
                    <h3>هل أنت متأكد أنك تريد حذف هذا المدرس؟</h3>
                    <button onClick={() => rejectAdmin()}>نعم</button>
                    <button onClick={() => setShowDeleteAdmin(false)}>لا</button>
                </div>
            )}
        </div>
    );
}